import * as React from 'react';
import { Row, Col } from 'react-bootstrap';
import { post } from '../../webapi';
import { Pagination } from '../';
import * as core from '../../Model/core';
import { Subject } from '../../Model/core';
import { tagEventHandler } from '../../Event/Handlers';
import { getQueryStringValue } from '../../util';

namespace LatestArticles {
    export interface Props {
        queryKey: string;
        itemsToTake: number;
        mainArticleIds: string;
        shouldHideMainArticles: boolean;
        scrollToElement: Element | null;
        fetchChildren: boolean;
        currentPageId: number;
        apiEndpoint: string;
        childrenOf: number;
        allowedTagIds: string;
    }

    export interface State {
        articles: core.Article[];
        topArticles: core.Article[] | null;
        subjectToFetch?: Subject;
    }
}

export class LatestArticlesComponent extends React.Component<LatestArticles.Props, LatestArticles.State> {
    private paginationRef: any;
    constructor(props: LatestArticles.Props) {
        super(props);
        this.state = {
            articles: [],
            topArticles: null
        };

        this.fetchArticles = this.fetchArticles.bind(this);
        this.onSubjectChange = this.onSubjectChange.bind(this);
    }

    componentDidMount() {
        const { allowedTagIds } = this.props;
        if (!allowedTagIds) {
            // Only register eventhandler if allowedTagIds is not defined
            tagEventHandler.register(this.onSubjectChange);
        } else {
            this.fetchArticles(1);
        }
    }

    onSubjectChange(subjectToFetch?: Subject) {
        this.setState({ subjectToFetch }, () => {
            if (this.paginationRef) {
                this.paginationRef.goToPage(1);
            }
            this.scrollToArticles();
        });
    }

    scrollToArticles() {
        const { scrollToElement } = this.props;
        if (scrollToElement !== null) {
            scrollToElement.scrollIntoView();
        }
    };

    async fetchArticles(currentPage: number): Promise<core.PaginationData | null> {
        const { subjectToFetch } = this.state;
        const { itemsToTake, mainArticleIds, fetchChildren, currentPageId, apiEndpoint, shouldHideMainArticles, childrenOf, allowedTagIds } = this.props;
        const result = await post<core.ArticlesData | null>(
            apiEndpoint,
            {
                itemsToTake,
                currentPage,
                mainArticleIds,
                subjectId: allowedTagIds.length > 0 ? null : subjectToFetch?.PageId ?? null,
                fetchChildren,
                currentPageId,
                shouldHideMainArticles,
                childrenOf,
                allowedTagIds
            }
        );

        this.setState({
            articles: result?.Articles ?? [],
            topArticles: result?.TopArticles ?? []
        });

        return result?.Pagination ?? null;
    }

    render() {
        const { queryKey } = this.props;
        const { articles, topArticles } = this.state;
        return (
            <Row>
                {topArticles !== null && !this.props.shouldHideMainArticles &&
                    <Articles
                        articles={topArticles}
                        xs={12}
                        md={6}
                        xl={5}
                        classNameFunc={(idx) => idx === 0 ? 'offset-xl-1 pb-5 pb-xl-0 mb-5' : 'mb-5'}
                    />
                }
                <Articles articles={articles} xs={12} md={4} xl={3} className="mb-5" />
                <div className="bl-pagination text-center">
                    <Pagination
                        ref={ref => { this.paginationRef = ref; }}
                        onPageChange={this.fetchArticles}
                        queryKey={queryKey}
                        runOnMount={!getQueryStringValue('subject')}
                    />
                </div>
            </Row>
        );
    }
}

type ArticlesProps = {
    articles: core.Article[];
    xs?: number | undefined;
    sm?: number | undefined;
    md?: number | undefined;
    xl?: number | undefined;
    className?: string;
    classNameFunc?: (idx: number) => string;
};

const Articles = ({ articles, xl, sm, md, xs, className, classNameFunc }: ArticlesProps) => {
    return (
        <>
            {articles.map((article, idx) => {
                const cls = classNameFunc ? classNameFunc(idx) : className;
                return (
                    <Col key={article.PageId} xs={xs} sm={sm} md={md} xl={xl} className={cls}>
                        <div className="card" style={{ minHeight: '250px' }}>
                            <a href={article.ArticleLink} title={article.Title}>
                                <img src={article.ImageUrl} />
                            </a>
                            <div className="card-body p-0">
                                <span className="card-published pt-3 pb-2">{article.Published}</span>
                                <h5 className="card-title">
                                    <a href={article.ArticleLink} title={article.Title}>{article.Title}</a>
                                </h5>
                                <p className="card-text" dangerouslySetInnerHTML={{ __html: article.Description }}></p>
                                <a href={article.ArticleLink} title={article.Title}>Läs mer »</a>
                            </div>
                        </div>
                    </Col>
                );
            })}
        </>
    );
};